import { DEFAULT_SITE } from './siteDefaults';

function strPrefer(a, b, fallback) {
  if (typeof a === 'string' && a.trim()) return a.trim();
  if (typeof b === 'string' && b.trim()) return b.trim();
  return typeof fallback === 'string' ? fallback : '';
}

const FALLBACK_SECTION_LABEL = 'Sustainable Farming';
const FALLBACK_SECTION_TITLE = 'Cultivating Excellence in Every Green Field';
const FALLBACK_INTRO =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat duis aute irure dolor.';

const FALLBACK_CTA_LABEL = 'Get In Touch';
const FALLBACK_CTA_HREF = '#contact';

const FALLBACK_CARDS = [
  {
    image:
      'https://images.unsplash.com/photo-1551754655-cd27e38d2076?auto=format&fit=crop&w=900&q=80',
    alt: 'Fresh corn cobs',
    stat: '80%',
    label: 'Efficiency',
    offset: false,
  },
  {
    image:
      'https://images.unsplash.com/photo-1574323347407-f5e1ad6d020b?auto=format&fit=crop&w=900&q=80',
    alt: 'Corn kernels and seeds',
    stat: '98%',
    label: 'Increase in Yields',
    offset: true,
  },
  {
    image:
      'https://images.unsplash.com/photo-1530836366310-e727b5070da6?auto=format&fit=crop&w=900&q=80',
    alt: 'Young corn plants in the field',
    stat: '50%',
    label: 'Farm Growth',
    offset: false,
  },
];

function resolveOffset(stored, bundled, fallback) {
  if (stored && typeof stored.offset === 'boolean') return stored.offset;
  if (bundled && typeof bundled.offset === 'boolean') return bundled.offset;
  return fallback;
}

function resolveCard(stored, bundled, fallback, index) {
  const s = stored && typeof stored === 'object' ? stored : {};
  const b = bundled && typeof bundled === 'object' ? bundled : {};
  const f = FALLBACK_CARDS[index] || FALLBACK_CARDS[0];
  return {
    image: strPrefer(s.image, b.image, f.image),
    alt: strPrefer(s.alt, b.alt, f.alt),
    stat: strPrefer(s.stat, b.stat, f.stat),
    label: strPrefer(s.label, b.label, f.label),
    offset: resolveOffset(s, b, f.offset),
  };
}

/** Sustainable farming section copy from API / bundled defaults. */
export function resolveSustainableFarming(site) {
  const d =
    DEFAULT_SITE.sustainableFarming && typeof DEFAULT_SITE.sustainableFarming === 'object'
      ? DEFAULT_SITE.sustainableFarming
      : {};
  const x =
    site?.sustainableFarming && typeof site.sustainableFarming === 'object'
      ? site.sustainableFarming
      : {};
  const storedCards = Array.isArray(x.cards) ? x.cards : [];
  const bundledCards = Array.isArray(d.cards) ? d.cards : [];
  return {
    sectionLabel: strPrefer(x.sectionLabel, d.sectionLabel, FALLBACK_SECTION_LABEL),
    sectionTitle: strPrefer(x.sectionTitle, d.sectionTitle, FALLBACK_SECTION_TITLE),
    intro: strPrefer(x.intro, d.intro, FALLBACK_INTRO),
    ctaLabel: strPrefer(x.ctaLabel, d.ctaLabel, FALLBACK_CTA_LABEL),
    ctaHref: strPrefer(x.ctaHref, d.ctaHref, FALLBACK_CTA_HREF),
    cards: [0, 1, 2].map((i) => resolveCard(storedCards[i], bundledCards[i], FALLBACK_CARDS[i], i)),
  };
}
